import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

export default function TableToggle({ options, value, onChange, layoutId = 'tableToggleActiveBackground' }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        bgcolor: '#f1f5f9',
        borderRadius: '12px',
        p: 0.5,
        position: 'relative',
        border: 'none'
      }}
    >
      {options.map((option) => {
        const optionId = option.id !== undefined ? option.id : option.value;
        const isActive = value === optionId;

        return (
          <Box
            key={optionId}
            component="button"
            onClick={() => onChange(optionId)}
            sx={{
              position: 'relative',
              borderRadius: '8px',
              px: 2,
              py: 0.5,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'Poppins',
              fontSize: '12px',
              fontWeight: 600,
              color: isActive ? '#ff502d' : '#64748b',
              bgcolor: 'transparent',
              outline: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
              transition: 'color 0.25s ease',
              '&:hover': {
                color: isActive ? '#ff502d' : '#334155'
              }
            }}
          >
            {option.label}
            {isActive && (
              <motion.div
                layoutId={layoutId}
                transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: '#ffffff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  zIndex: -1
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
